// Base Resources

// https://github.com/cloudmix/cloudmix/wiki/Permissions-and-features

const WILD_CARD = '*'

// user-management-api resources (unchanged)
const ORG_RESOURCE_ID = 'org'
const ORG_GROUP_RESOURCE_ID = 'org_group'
const USAGE_RESOURCE_ID = 'usage'
const STAFF_RESOURCE_ID = 'staff'

// media-library-api resources (camelCase to match API)
const LIVE_INPUT_RESOURCE_ID = 'liveInput'
const LIVE_OUTPUT_RESOURCE_ID = 'liveOutput'
const ENCODING_PRESET_RESOURCE_ID = 'encodingPreset'

// media-library-api resources (already matching)
const AUTOMATION_RESOURCE_ID = 'automation'
const PROJECT_RESOURCE_ID = 'project'
const SESSION_RESOURCE_ID = 'session'
const RECORDING_RESOURCE_ID = 'recording'

// usage sub-resource string values (kept for usage_distribution / usage_session)
const DISTRIBUTION_RESOURCE_ID = 'distribution'

// Sub Resources (user-management-api)
const INVITATION_RESOURCE_ID = 'invitation'
const API_KEY_RESOURCE = 'api_key'
const SUBSCRIPTION_RESOURCE_ID = 'subscription'
const MEMBER_RESOURCE_ID = 'member'
const PROMOTE_OWNER_RESOURCE_ID = 'promote_owner'
const DEMOTE_OWNER_RESOURCE_ID = 'demote_owner'
const FEATURE_RESOURCE_ID = 'feature'
const STAFF_STAFF_MEMBER_RESOURCE_ID = 'staff_member'
const STAFF_END_USER_RESOURCE_ID = 'end_user'

const orgResource = {
  org: [ORG_RESOURCE_ID],
  org_invitation: [ORG_RESOURCE_ID, INVITATION_RESOURCE_ID],
  org_api_key: [ORG_RESOURCE_ID, API_KEY_RESOURCE],
  org_subscription: [ORG_RESOURCE_ID, SUBSCRIPTION_RESOURCE_ID],
  org_member: [ORG_RESOURCE_ID, MEMBER_RESOURCE_ID],
  org_promote_owner: [ORG_RESOURCE_ID, PROMOTE_OWNER_RESOURCE_ID],
  org_demote_owner: [ORG_RESOURCE_ID, DEMOTE_OWNER_RESOURCE_ID],
  org_feature: [ORG_RESOURCE_ID, FEATURE_RESOURCE_ID],
}

const orgGroupResource = {
  org_group: [ORG_GROUP_RESOURCE_ID],
  org_group_invitation: [ORG_GROUP_RESOURCE_ID, INVITATION_RESOURCE_ID],
}

const staffResource = {
  staff: [STAFF_RESOURCE_ID],
  staff_staff_member: [STAFF_RESOURCE_ID, STAFF_STAFF_MEMBER_RESOURCE_ID],
  staff_end_user: [STAFF_RESOURCE_ID, STAFF_END_USER_RESOURCE_ID],
  staff_org: [STAFF_RESOURCE_ID, ORG_RESOURCE_ID],
}

const usageResource = {
  usage: [USAGE_RESOURCE_ID],
  usage_distribution: [USAGE_RESOURCE_ID, DISTRIBUTION_RESOURCE_ID],
  usage_session: [USAGE_RESOURCE_ID, SESSION_RESOURCE_ID],
}

export const RESOURCE_ID = {
  wild_card: [WILD_CARD],

  // user-management-api groups
  ...orgResource,
  ...orgGroupResource,
  ...staffResource,
  ...usageResource,

  // media-library-api org resources (renamed to camelCase)
  liveInput: [LIVE_INPUT_RESOURCE_ID],
  liveOutput: [LIVE_OUTPUT_RESOURCE_ID],
  encodingPreset: [ENCODING_PRESET_RESOURCE_ID],

  // media-library-api org resources (already matching)
  automation: [AUTOMATION_RESOURCE_ID],
  project: [PROJECT_RESOURCE_ID],
  session: [SESSION_RESOURCE_ID],
  recording: [RECORDING_RESOURCE_ID],

  // new media-library-api org resources
  enginePool: ['enginePool'],
  mediaExport: ['mediaExport'],
  mediaItem: ['mediaItem'],
  mediaItemClip: ['mediaItemClip'],
  projectSession: ['project', 'session'],
  projectSessionLobby: ['project', 'session', 'lobby'],
  region: ['region'],
  workflowSession: ['workflowSession'],
  workflowSessionLobby: ['workflowSession', 'lobby'],

  // new staff resources
  engine: ['engine'],
  engineReleaseChannel: ['engineReleaseChannel'],
  jobEngine: ['job', 'engine'],
  jobSession: ['job', 'session'],
} as const
